// src/routes/RoleRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function RoleRoute({ children, allowedRoles }) {
    const { isAuthenticated, role, loading } = useAuth();

    if (loading) return null; // or spinner
    if (!isAuthenticated) return <Navigate to="/login" replace />;
    if (!allowedRoles.includes(role)) return <Navigate to="/unauthorized" replace />;

    return children;
}
